"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "deviceTypes", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.deviceTypes;
  }
});
Object.defineProperty(exports, "getIcon", {
  enumerable: true,
  get: function () {
    return _getIcon.getIcon;
  }
});
Object.defineProperty(exports, "getIconAsync", {
  enumerable: true,
  get: function () {
    return _getIcon.getIconAsync;
  }
});
Object.defineProperty(exports, "getUxIcon", {
  enumerable: true,
  get: function () {
    return _getIcon.getUxIcon;
  }
});
Object.defineProperty(exports, "useDeviceType", {
  enumerable: true,
  get: function () {
    return _sharedFunctions.useDeviceType;
  }
});
Object.defineProperty(exports, "useFormatMessage", {
  enumerable: true,
  get: function () {
    return _formatMessage.useFormatMessage;
  }
});
Object.defineProperty(exports, "usePlaceholderHints", {
  enumerable: true,
  get: function () {
    return _usePlaceholderHints.usePlaceholderHints;
  }
});
Object.defineProperty(exports, "usePrevious", {
  enumerable: true,
  get: function () {
    return _usePrevious.usePrevious;
  }
});
var _sharedFunctions = require("./sharedFunctions");
var _getIcon = require("./getIcon");
var _usePlaceholderHints = require("./hooks/usePlaceholderHints");
var _usePrevious = require("./hooks/usePrevious");
var _formatMessage = require("./hooks/formatMessage");